<template>
  <div style=" color: #666">
    <div class="style-row">
      <span class="label">Override Value</span>
      <InputNumber
          inputId="override"
          v-model.number="overrideValue"
          :inputStyle="{ width: '100px' }"
      />
      <Button v-if="overrideValue != null" icon="pi pi-trash" @click="overrideValue = null"></Button>
    </div>

    <div class="style-row">
      <span class="label">Min</span>
      <InputNumber
          :maxFractionDigits="1"
          inputId="min"
          v-model="widgetMin"
          :step="1"
          :inputStyle="{ width: '100px' }"
      />
      <Button v-if="widgetMin != null" icon="pi pi-trash" @click="widgetMin = null"></Button>
    </div>

    <div class="style-row">
      <span class="label">Max</span>
      <InputNumber
          :maxFractionDigits="1"
          inputId="max"
          v-model="widgetMax"
          :step="1"
          :inputStyle="{ width: '100px' }"
      />
      <Button v-if="widgetMax != null" icon="pi pi-trash" @click="widgetMax = null"></Button>
    </div>

    <div class="style-row">
      <span class="label">Step</span>
      <InputNumber
          :maxFractionDigits="3"
          inputId="Step"
          v-model="step"
          :step="1"
          showButtons
          :min="0.001"
      />
    </div>



    <div style="margin-bottom: 20px"></div>
  </div>
</template>
<script setup lang="ts">
import {computed, ref, watch} from 'vue'
import {useWidgetStore} from "@/store";
import {storeToRefs} from "pinia";
import useComputedTreeValue from "@/views/components/element/hooks/useComputedTreeValue";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";


const widgetStore = useWidgetStore()
const {selectedWidget} = storeToRefs(widgetStore)


const { getActiveHookId, getComputedMinMax } = useComputedTreeValue()

watch(selectedWidget, () => {
  if (selectedWidget.value) {
    getActiveHookId(selectedWidget.value.hookId)
  }
})

const widgetMax = computed({
  get() {
    return selectedWidget.value.max ? selectedWidget.value.max : null
  },
  set(val) {
    selectedWidget.value.max = val
  }
})

const widgetMin = computed({
  get() {
    return selectedWidget.value.min ? selectedWidget.value.min : null
  },
  set(val) {
    selectedWidget.value.min = val
  }
})

const overrideValue = computed({
  get() {
    return selectedWidget.value.overrideValue !== undefined && selectedWidget.value.overrideValue !== null
        ? selectedWidget.value.overrideValue
        : null;
  },
  set(val) {
    selectedWidget.value.overrideValue = val
  }
})

const options = ref([
  '%',
  'px'
])

const step = computed({
  get() {
    return selectedWidget.value?.step ?? 1
  },
  set(val) {
    // down arrow from 1 will get you 0.1
    if ((!selectedWidget.value.step || selectedWidget.value.step === 1) && val == 0.001) {
      val = 0.1
    }
    selectedWidget.value.step = val
  }
})

const widthPx = computed({
  get() {
    return selectedWidget.value?.widthUnit ?? '%'

  },
  set(val) {
    selectedWidget.value.widthUnit = val
  }
})

const width = computed({
  get() {
    return selectedWidget.value?.width ?? 1
  },
  set(val) {
    selectedWidget.value.width = val
  }
})

const slider = computed({
  get() {
    return selectedWidget.value?.slider ?? false
  },
  set(val) {
    selectedWidget.value.slider = val
  }
})

</script>

<style scoped>
:deep(.p-inputtext) { width: 50px; }

span.label { display: inline-block; width: 100px }
span.label-long { display: inline-block; width: 100px }

.style-section { margin-top: 20px; margin-bottom: 20px;}
.style-row { margin-top: 5px; width: 300px; align-items: center; display: flex  }

:deep(.p-highlight span) { z-index: 100; }
:deep(.p-selectbutton .p-button::before) {
  transition: none !important;
}

.group {
  display: flex;
  align-items: center;
}
</style>
